import { FONT_WEIGHT } from '@app/styles/themes/constants';
import styled from 'styled-components';

export const ChatContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  border: none;
  border-radius: 12px;
  overflow: hidden;
  padding-block-end: 20px;
`;

export const MessagesWrapper = styled.div`
  flex: 1;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
  overflow-y: auto;
  background: transparent;
  margin-top: 16px;
  padding-inline: 24px;
  height: calc(100% - 72px);
`;

export const MessageRow = styled.div<{ isOwn: boolean }>`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  justify-content: ${(p) => (p.isOwn ? 'flex-end' : 'flex-start')};

  .ant-avatar {
    color: #000;
  }

  .avatar-wrapper {
    margin-top: 0 !important;
  }
`;

export const MessageBubble = styled.div<{ isOwn: boolean }>`
  background: ${(p) => (p.isOwn ? '#E7F2FB' : '#f8f9fa')};
  color: ${(p) => (p.isOwn ? '#000000' : '#000000')};
  padding: 8px 12px;
  border-radius: 12px;
  max-width: 70%;
  font-size: 14px;
  font-weight: ${FONT_WEIGHT.regular};
  line-height: 1.4;

  &.preview {
    background: #f8f9fa;
  }
`;

export const Message = styled.div`
  font-size: 14px;
  color: #000;
  font-weight: ${FONT_WEIGHT.regular};
  margin-bottom: 2px;
`;

export const Time = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 9px;
  color: #828282;
  font-weight: ${FONT_WEIGHT.regular};
  margin-bottom: 2px;
`;

export const SenderName = styled.div`
  font-size: 11px;
  font-weight: 500;
  opacity: 0.7;
  margin-bottom: 2px;

  &.personal-message {
    min-height: 32px;
    display: flex;
    align-items: center;
  }

  &.own-message {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
`;

export const InputWrapper = styled.div`
  padding: 16px;
  border-top: 1px solid #dcdcdc;
  background: #fff;
  width: 100%;
  position: absolute;
  bottom: 0;

  .ant-input-affix-wrapper {
    border: 1px solid #dcdcdc;
    padding-block: 0;

    .ant-input-suffix {
      background: #243161;
      width: 32px;
      height: 32px;
      margin-block: auto;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 8px;
      transform: rotate(180deg);
    }

    .ant-input {
      height: 46px;
    }
  }
`;

export const UserList = styled.div`
  min-width: 100%;
  overflow-x: auto;
  border-bottom: 1px solid #dcdcdc;
  display: flex;
  align-items: center;
  white-space: nowrap;
  background: #fff;
  gap: 8px;
  padding: 8px 0;
  padding-inline: 24px;

  .ant-avatar {
    flex: 0 0 auto;
    color: #000;
    cursor: pointer;
  }

  .ant-col {
    padding: 0 !important;
  }

  .active {
    background-color: #243161 !important;
    color: #fff;
  }
`;

export const ActionWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  justify-content: flex-end;
  padding-inline: 24px;
  margin-top: 4px;
`;

export const Link = styled.a`
  color: #243161;
  text-decoration: underline;
  cursor: pointer;
  font-weight: ${FONT_WEIGHT.medium};
  word-break: break-all;
  &:hover {
    text-decoration: none;
    color: #243161;
  }

  &.disabled {
    opacity: 0.6;
    text-decoration: none;
  }
`;

export const MessageOptions = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
  background: white;
  border-radius: 8px;
  padding: 8px;
  width: fit-content;
  font-size: 16px;
`;

export const PreviewMessageContent = styled.div`
  background: #e7f2fb;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
  padding: 32px;
`;
